import { resolveUiLocale } from '@/utils/uiLocale';

export type ChartGranularity = 'week' | 'month';

export function formatChartBucketLabel(
  isoDate: string,
  granularity: ChartGranularity,
  language?: string | null,
): string {
  const locale = resolveUiLocale(language);
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return isoDate;
  if (granularity === 'month') {
    return d.toLocaleDateString(locale, { month: 'short', year: '2-digit' });
  }
  return d.toLocaleDateString(locale, { day: '2-digit', month: 'short' });
}

export function formatChartTooltipLabel(
  isoDate: string,
  granularity: ChartGranularity,
  language?: string | null,
): string {
  const locale = resolveUiLocale(language);
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return isoDate;
  if (granularity === 'month') {
    return d.toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  }
  return d.toLocaleDateString(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
